import React from "react";
import sonmargImg from "../../assets/images/epic-banner.jpg";
import travel from "../../assets/images/Travel-With-Us.png";
import gondolaPic from "../../assets/images/gondolaPic.jpg";
import flight from "../../assets/images/flight.jpg";
import { FaWhatsapp } from "react-icons/fa";

const Ticket = () => {
  const handleWhatsAppRedirect = () => {
    const phoneNumber = "+916006098901";
    const message = "I am interested in Gondola ticket booking!";
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.location.href = whatsappURL;
  };

  // const handleWhatsAppGroupRedirect = () => {
  //   const groupURL = "https://chat.whatsapp.com/KuVyyZn2cobF0ejhNXY1Ey";
  //   window.location.href = groupURL;
  // };

  return (
    <>
      <div className="relative w-full h-[200px] lg:h-[400px]">
        <img
          src={sonmargImg}
          alt="Banner"
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <img
            src={travel}
            alt="travel"
            className="object-cover max-w-[30%] max-h-[30%]"
          />
        </div>
      </div>

      <div className="container mt-20">
        <h2 className="text-2xl lg:text-4xl font-semibold text-center mb-8">
          Book Your Tickets
        </h2>

        {/* Gondola Ticket Section */}
        <div className="grid lg:grid-cols-2 gap-8 md:grid-cols-2 grid-cols-1 mx-4 lg:mx-0">
          <div className="flex flex-col md:flex-row  justify-center gap-6 text-center bg-gray-900 text-white p-6 rounded-lg shadow-lg">
            <div>
              <img
                src={gondolaPic}
                alt="travel"
                className="object-cover h-full rounded-sm hover:scale-105 transtion-all duration-500"
              />
            </div>

            <div className="flex flex-col items-center justify-between">
              <div>
                <h3 className="text-xl font-bold mb-4">Gondola Ticket</h3>
                <p className="mb-4 max-w-[550px]  ">
                  Enjoy a scenic gondola ride through the mountains of Kashmir.
                  A must-do experience for every visitor.
                </p>
              </div>
              <button
                onClick={() => handleWhatsAppRedirect()}
                className="bg-red-500 text-white py-2 px-4 rounded-lg flex items-center justify-center hover:bg-red-600"
              >
                <FaWhatsapp size={20} className="mr-2 " /> Check Availability
              </button>
            </div>
          </div>

          {/* Flight Ticket Section */}

          <div className="flex  flex-col md:flex-row  justify-center gap-6 text-center bg-gray-900 text-white p-6 rounded-lg shadow-lg">
            <div>
              <img
                src={flight}
                alt="flight"
                className="object-cover h-full rounded-sm hover:scale-105 transtion-all duration-500"
              />
            </div>
            <div className="flex flex-col items-center justify-between">
              <div>
                <h3 className="text-xl font-bold mb-4">Flight Ticket</h3>
                <p className="mb-4 w-full max-w-[550px] ">
                  Book your flight tickets to Kashmir for a smooth travel
                  experience.
                </p>
              </div>
              <button
                onClick={() => handleWhatsAppRedirect()}
                className="bg-red-500 text-white py-2 px-4 rounded-lg flex items-center justify-center hover:bg-red-600"
              >
                <FaWhatsapp size={20} className="mr-2 " /> Check Availability
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ticket;
